module.exports = [{
        regexp: /^\/smugmug(.*)\/?$/i,
        routeHash: '$2a$10$CJqvloHEDKVyjwyVT.c.q.WYknOCqs.Um./US052bycbeW12aiFbK',
        passHash: '$2a$10$Y3jwr/9sLIg.rcxplevh1uZ6Hz85kqJTn21xZHldG42tiHAIYUb.a'
      },{
        regexp: /^\/client\/wdfw(.*)\/?$/i,
        routeHash: '$2a$10$vsV9Q5Pdue3mgmffNxlr2OV4AQnaVU27r/AS0PgXAJGeq7k2tLVmW',
        passHash: '$2a$10$hM6QDEoThslXltql3z84L.cn9uCUuX5Y52mEIlltuT3FzKoy9Nm1G'
      },{
        regexp: /^\/client\/ots(.*)\/?$/i,
        routeHash: '$2a$10$Dx2HydIllNQawNbkjEaPzOBYqSOYd3oaz22M1oiKZxotVyE92Pr7a',
        passHash: '$2a$10$qPXH.46i9oXgSgyA9ox3GOCgeHgD1dHDLgNL38P2mLh7mLIJFJ01e'
      },{
        regexp: /^\/client\/methow-conservancy(.*)\/?$/i,
        routeHash: '$2a$10$jqGByKAATSmoisI9Pbm22uxp9GdvpDm.R0HXKpwdm0m6H/oDmO1pC',
        passHash: '$2a$10$Qpxybg2lQ2qc.mV.x7ZVa.y8anaAXY765BSHGv/Wy9QqbThc431oW'
      },{
        regexp: /^\/client\/jamies-place(.*)\/?$/i,
        routeHash: '$2a$10$cwlxgEpKmK7twqLqPX9eM.i5BbiRKSU8F.uxHdrkT7EhUa372DHO2',
        passHash: '$2a$10$WovRV4/jJKcfM1BWrQobUOpK7wLTvfFjHH/SEEsg.zZ1Pnix5LgoO'
      },{
        regexp: /^\/client\/ilcp(.*)\/?$/i,
        routeHash: '$2a$10$g4lkyB6P.26nt45XC71n7O4CiLbClctAmB/iAuqoQzzdGO0DBAFOC',
        passHash: '$2a$10$ssZ26XaKz9mRk9cz3rfyb.zpx/n8lXNQReyb8nJ.GRRjqvTJ2K77S'
      },{
        regexp: /^\/client\/ec-rae(.*)\/?$/i,
        routeHash: '$2a$10$D.h9pCY.1L0ue5nOTdhGKOrHNa4.duFJk7qFvtfx4KGoteqsIA4k.',
        passHash: '$2a$10$aMYkN.R90k6ZeXYl3aybkepQyunRoAYyUh/0h8vrW59uVhSy0fiBS'
      },{
        regexp: /^\/client\/earth-justice\/headwaters-portraits(.*)\/?$/i,
        routeHash: '$2a$10$q0Dh0VXLsk7i3ECq7OuW4e4pfzAD/AzoZb2tVP6jedOz6tE6YTSea',
        passHash: '$2a$10$pq9cZ1iEw/5FI6s9LP7bm.Pd738Uugr.SJUu1gzlO7iq3HydWruT.'
      },{
        regexp: /^\/client\/anthropocene(.*)\/?$/i,
        routeHash: '$2a$10$OYD0Oqof36QPfZmYane4Nu5FWdgu4OMhIRhKpaMN88A21yQ6CV5rS',
        passHash: '$2a$10$lXr1D9ltKVlOinHjdMJ0re.cyuhK28FNXFxUbZ7TA9dz/6LMBbfYG'
      },{
        regexp: /^\/client\/alexanddane(.*)\/?$/i,
        routeHash: '$2a$10$32FtBPpgc3HxZPObKZoEfudXn8NCrM48.zdKnBVEh9AII3vS686CO',
        passHash: '$2a$10$6nMafB4HYVsPHOaIFCnP4euWKfnJvJBR5eEhOPTrI3m/OSeMbrERy'
      }]


// WEBPACK FOOTER //
// ./app/.generated/auth.js